import React from "react";
import Scaffold from "../commons/scaffold/scaffold";
import SoldOutCMSEditorEquipment from "./sold_out_cms_editor_equipment";
import SoldOutCMSEditorMasterItem from "./sold_out_cms_editor_master_item";
import SoldOutCMSEditorOperational from "./sold_out_cms_editor_operational";

export default class SoldOutCMSEditorSelectionScreen extends React.Component {
    render(): React.ReactNode {
        return (
            <Scaffold>
                <div className=" bg-slate-500 overflow-x-auto min-h-screen p-5 mt-10 relative">
                    <h1 className="text-white text-3xl text-center font-bold flex-grow m-5">
                        Sold Out CMS Editor
                    </h1>
                    <div>
                        <button
                            className="mx-1 px-3 py-1 rounded-md bg-blue-500 hover:bg-blue-700 text-white"
                            onClick={() => {
                                window.location.href = SoldOutCMSEditorMasterItem.path;
                            }}
                        >
                            Edit Master Item
                        </button>
                        <button
                            className="mx-1 px-3 py-1 rounded-md bg-blue-500 hover:bg-blue-700 text-white"
                            onClick={() => {
                                window.location.href = SoldOutCMSEditorEquipment.path;
                            }}
                        >
                            Edit Equipment
                        </button>
                        <button
                            className="mx-1 px-3 py-1 rounded-md bg-blue-500 hover:bg-blue-700 text-white"
                            onClick={() => {
                                window.location.href = SoldOutCMSEditorOperational.path;
                            }}
                        >
                            Edit Case Operational
                        </button>
                    </div>
                </div>
            </Scaffold>
        );
    }
}